<template>
<div class="flex-container">
    <md-layout md-vertical-align="center" v-if="ready">
        <md-layout md-flex="30" md-flex-offset="35" md-align="center">
            <h1>
                <img :src="require('../assets/img/cuelistBLACK.png')" alt="LOGO"/>
            </h1>
        </md-layout>
        <md-layout md-flex="100" md-align="center" >
            <h1 class="md-headline">Collaborate on <strong>{{project.title}}</strong></h1>
        </md-layout>
        <md-layout md-flex="100" md-align="center" v-if="validCollab">
            <md-layout md-flex="100" md-align="center">
                <md-button class="md-raised md-primary" @click="accept"><md-icon>person</md-icon>&nbsp;Accept Invite</md-button>
            </md-layout>    
        </md-layout>
        <md-layout md-flex="100" md-align="center" v-if="!validCollab">
            <h2 class="md-title">You have not been invited to this project.</h2>
        </md-layout>
    </md-layout>
</div>
</template>

<script>
import firebase from 'firebase';
import { mapGetters } from 'vuex';
import CoreFooter from '@/components/core/footer';

const AcceptInviteView = {
    name: 'AcceptInviteView',
    props: ['id'],
    data: function() {
        return {
            ready: false,
            validCollab: null
        };
    },
    watch: {
        project: function() {
            this.checkProjectStatus();
        },
        user: function() {
            this.checkProjectStatus();
        }
    },
    methods: {
        setValidCollab() {
            const index = this.pendingCollaborators.findIndex((pc) => {
                return pc.email === this.user.email;
            });

            if (index > -1) {
                this.validCollab = this.pendingCollaborators[index];
            }
        },
        accept() {
            this.$store.dispatch('addCollaborator', {
                project: this.project,
                uid: this.user.uid,
                pendingCollaborator: this.validCollab
            });

            this.$store.dispatch('showAllLayers');

            this.$router.replace(`/project/${this.id}`);
        },
        checkProjectStatus() {
            if (this.project || (this.user && this.user.uid)) {
                this.ready = true;

                const index = this.pendingCollaborators.findIndex((pc) => {
                    return (pc.email || '').toLowerCase() === (this.user.email || '').toLowerCase();
                });

                if (index > -1) {
                    this.validCollab = this.pendingCollaborators[index];
                }
            }
        }
    },
    components: {
        'core-footer': CoreFooter
    },
    computed: {
        ...mapGetters([
            'project',
            'user',
            'layers',
            'pendingCollaborators'
        ])
    },
    beforeRouteEnter: function(to, from, next) {
        next((vm) => {
            console.log(firebase.auth().currentUser);
            vm.$store.dispatch('setActiveProject', {
                ref: firebase.database().ref(`projects/${vm.id}`),
                options: { }
            });
            vm.$store.dispatch('setActiveUser', {
                ref: firebase.database().ref(`users/${firebase.auth().currentUser.uid}`),
                options: { }
            });
        });
    }
};
export default AcceptInviteView;
</script>

<style>

</style>


// WEBPACK FOOTER //
// accept-invite.vue?b8fa7836